import {autoImplement} from '@/util';

export interface ApiArticleStock {
  ArtikelNr: string;
  Niederlassung: number;
  Lagerhalle: number;
  Lagerfach: number;
  ChargenNr: number;
  BestandVerfuegbar: number;
  BestandPhysikalisch: number;
  BestandBuch: number;
  MengeBestellt: number;
  MengeAngeliefert: number;
  MengeReserviert: number;
  MengeManuellReserviert: number;
  MengeAusgeliefert: number;
  MengeIntern: number;
  LetztDatum: string;
  Fremdlager: string;
}

export default class ArticleStock extends autoImplement<ApiArticleStock>() {
  static fromApi(apiArticleStock: ApiArticleStock): ArticleStock {
    return new ArticleStock(apiArticleStock);
  }
}
